import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import poll from '../../lib/poll';
import { nodeChatOnPageValidator } from '../../lib/node-chat-on-page-validator';
import { loadChatIneligibleModalContainer } from '../../contactUs/actions/action-chat-ineligible-modal';
import { loadMessageModal } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedFalseAction } from '../../contactUs/actions/action-chat-bot';
import { initiateAsyncChat } from '../../lib/asyncMessageHelper';
import l10n from '../../lib/reactPPl10nHelper';
import { asyncOrigins, chatBotMessageUsRefIdsMapping } from '../../common/commonConstants';
import {
  initializeChatBot,
  initiateChatBot,
  isChatBotClickedOnArticlePage,
  setArticlePageChatBotClickInSession,
  setChatBotClickInSession,
} from '../../lib/chat-bot-live-helper';

const modalErrorMsg = l10n.getContent('smarthelp/info.info.title.functionIsUnavailable');

// the Poll function will retry for at least 3.20 secs based on current retries = 5 and delay = 200 ms
const pollRetries = 5;
const pollDelay = 200;

function setChatBotLoaded() {
  return { type: types.SET_CHAT_BOT_LOADED };
}

// This function is to open chat automatically when the post chat bot service returns Trigger Mode as OPEN.
export function chatBotLoaded() {
  return (dispatch) => {
    // Trigger Async Chat for the Async Pilot users
    if (Page.isPilotUser()) {
      // updated for : DTHLPCN-2155
      return initiateAsyncChat({
        topicRefId: chatBotMessageUsRefIdsMapping.GENPOOL_HOME_PAGE,
        origin: asyncOrigins.CHAT_PILL,
      });
    }

    // Waits at least 3.20 secs based on current retries = 5 and delay = 200 ms
    return poll(nodeChatOnPageValidator, pollRetries, pollDelay).then(() => {
      trackPage({ id: 'chatBot' });
      dispatch(setChatBotLoaded());
      // eslint-disable-next-line no-undef
      initiateChatBot(chatBotMessageUsRefIdsMapping.GENPOOL_HOME_PAGE);
    });
  };
}

// displaying chatBot in the HCR article/FAQ page
export function displayChatBot() {
  return (dispatch, getState) => {
    const isLoggedIn = Page.isLoggedIn();

    // postchatBotEligibity API response check for Chatbot Eligibility
    const chatBotEligibilityCheck = _get(getState(), 'postChatBotEligibility.chatBotDisplay');

    if (!isLoggedIn) {
      return null;
    }

    /**
     * if ChatBot is not enabled for this article triggering chat ineligible modal
     */
    const loadChatIneligibleModal = !chatBotEligibilityCheck;

    if (isChatBotClickedOnArticlePage()) {
      setChatBotClickInSession(false);

      // removing articleChatBotClicked from sessionStorage to avoid error message reopening
      setArticlePageChatBotClickInSession(false);

      // Show error message for Lexa service failed
      if (Page.isLexaPilotFailure()) {
        trackPage({ id: 'articleLexaFailureError', link: 'smarthelp-intermediate|lexa-failure' });
        return dispatch(loadMessageModal({ message: modalErrorMsg }));
      }

      // checking if the article is eligible for chatBot
      if (chatBotEligibilityCheck) {
        dispatch(chatBotClickedFalseAction()); // making chatClicked false

        // Trigger Async Chat for the Async Pilot users
        if (Page.isPilotUser()) {
          return initiateAsyncChat({
            topicRefId: chatBotMessageUsRefIdsMapping.GENPOOL_ARTICLE_PAGE,
            origin: asyncOrigins.CHAT_PILL,
          });
        }

        return initializeChatBot({
          topicRefId: chatBotMessageUsRefIdsMapping.GENPOOL_ARTICLE_PAGE,
          origin: asyncOrigins.CHAT_PILL,
        });
      }
      if (loadChatIneligibleModal) {
        // If `articleChatBotClicked` is `true` we show the chat ineligible modal
        dispatch(loadChatIneligibleModalContainer());
      }

      dispatch(chatBotClickedFalseAction());
    }
    return { type: types.CHATBOT_FAQ_DISPLAY_CHECKER };
  };
}
